import { render, staticRenderFns } from "./VolunteerMatchDetail.vue?vue&type=template&id=6740bfde"
import script from "./VolunteerMatchDetail.vue?vue&type=script&lang=ts"
export * from "./VolunteerMatchDetail.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerMatchDetail.vue?vue&type=style&index=0&id=6740bfde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports